<template>
	<div class="fenz-document p-4">
		<div class="fenz-doc-section align-items-center">
			<div class="css-image fenz-logo fenz-logo-size">
				<h2 class="fenz-title">EVACUATION REPORT</h2>
			</div>
			
		</div>
		<div class="fenz-doc-section">
			<b>
				Send the completed report to the Fire Information Unit, by email <a :href="'mailto:evacuation@fireandemergency.nz'" class="fenz-link">evacuation@fireandemergency.nz</a> or post to
				Fire Information Unit, Fire and Emergency New Zealand, PO Box 68444, Victoria Street West, Auckland 1142.
			</b>
		</div>
		<div class="fenz-doc-section">
			<div class="header">
				<span>Part A</span>
				<span class="float-right">Building description</span>
			</div>
			<div class="body pt-3">
				<div class="grid fenz-grid">
					<div class="col-3 fenz-field-name">
						Building name
					</div>
					<div class="col-3">
						{{propertyData.buildingName}}
					</div>
					<div class="col-3 fenz-field-name">
						Scheme reference
					</div>
					<div class="col-3">
						{{evacuation.schemeReference}}
					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-3 fenz-field-name">
						Address
					</div>
					<div class="col">
						{{propertyData.streetAddress}} {{propertyData.postalAddress}} {{propertyData.suburb}} {{propertyData.city}}
					</div>
				</div>
			</div>
		</div>
		<div class="fenz-doc-section">
			<div class="header">
				<span>Part B</span>
				<span class="float-right">Contact person details</span>
			</div>
			<div class="body pt-3">
				<div class="grid fenz-grid">
					<div class="col-3 fenz-field-name">
						Contact person's name
					</div>
					<div class="col">
						<div contenteditable="true" class="input-div p-inputtext">
							{{ reportContact.name }}
						</div>
						</div>
					</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-3 fenz-field-name">
						Phone number
					</div>
					<div class="col-3">
						<div contenteditable="true" class="input-div p-inputtext">
							{{ reportContact.phone }}
						</div>
					</div>
					<div class="col-3 fenz-field-name">
						Mobile number
					</div>
					<div class="col-3">
						<div contenteditable="true" class="input-div p-inputtext">
							{{ reportContact.mobile }}
						</div>
					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-3 fenz-field-name">
						Email address
					</div>
					<div class="col">
						<div contenteditable="true" class="input-div p-inputtext">
						{{ reportContact.email }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="fenz-doc-section">
			<div class="header">
				<span>Part C</span>
				<span class="float-right">Evacuation details</span>
			</div>
			<div class="body pt-3">
				<div class="grid fenz-grid">
					<div class="col-3 fenz-field-name">
						Date of evacuation
					</div>
					<div class="col-3">
						<Calendar class="evac-date-calendar" v-model="dateOfEvacuation" dateFormat="d MM yy" :showButtonBar="true" @date-select="onDateOfEvacuationChange" />
						<div id="evacDate" contenteditable="true" class="evac-date-div input-div p-inputtext" />
					</div>
					<div class="col-3 fenz-field-name">
						Time of evacuation
					</div>
					<div class="col-3 flex align-items-center">
						<div contenteditable="true" class="input-div p-inputtext mr-2" />
						<span class="mr-1 p-1" v-bind:class="[evacTimeAM ? 'circled':'']" @click="evacTimeAM = !evacTimeAM;evacTimePM=false" >
							am
						</span>
							/ 
						<span class="ml-1 p-1" v-bind:class="[evacTimePM ? 'circled':'']" @click="evacTimePM = !evacTimePM;evacTimeAM=false" >
							pm
						</span>
					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-3 fenz-field-name">
						Time taken to evacuate
					</div>
					<div class="col flex align-items-center">
						<div contenteditable="true" class="input-div p-inputtext mr-2" />
						minutes
						<div contenteditable="true" class="input-div p-inputtext mr-2 ml-2" />
						seconds
					</div>
				</div>
			</div>
		</div>
		<div class="fenz-doc-section">
			<div class="header">
				<span>Part D</span>
				<span class="float-right">Assessment outcomes</span>
			</div>
			<div class="body pt-3">
				<div class="grid fenz-grid">
					<div class="col-fixed" style="width:30px">
					</div>
					<div class="col">
					</div>
					<div class="col-fixed" style="width:100px">
						<b>Yes</b>
					</div>
					<div class="col-fixed" style="width:100px">
						<b>No</b>
					</div>
					<div class="col-fixed" style="width:100px">
						<b>N/A</b>
					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-fixed" style="width:30px">
						1
					</div>
					<div class="col">
						Did any injuries occur during this trial evacuation? <br />
						<small>If yes, detail the injuries that occurred during the trial evacuation</small>
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox1Y" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox1N" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">

					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-fixed" style="width:30px">
						2
					</div>
					<div class="col">
						Was the evacuation alarm/method of alerting occupants clearly heard in all areas of the building? <br />
						<small>If no, detail issue and action taken to remedy it</small>
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox2Y" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox2N" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">

					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-fixed" style="width:30px">
						3
					</div>
					<div class="col">
						Were all exit ways clear? <br />
						<small>If no, detail issue and action taken to remedy it</small>
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox3Y" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox3N" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">

					</div>
				</div>
			</div>
		</div>
		<div class="fenz-doc-section">
			<div class="header">
				<span>Part D, continued</span>
				<span class="float-right">Assessment outcomes</span>
			</div>
			<div class="body pt-3">
				<div class="grid fenz-grid">
					<div class="col-fixed" style="width:30px">
					</div>
					<div class="col">
					</div>
					<div class="col-fixed" style="width:100px">
						<b>Yes</b>
					</div>
					<div class="col-fixed" style="width:100px">
						<b>No</b>
					</div>
					<div class="col-fixed" style="width:100px">
						<b>N/A</b>
					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-fixed" style="width:30px">
						4
					</div>
					<div class="col">
						Were 'FIRE ACTION NOTICES' in place? <br />
						<small>If no, detail issue and action taken to remedy it</small>
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox4Y" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox4N" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">

					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-fixed" style="width:30px">
						5
					</div>
					<div class="col">
						Were systems in place to assist anyone who could not self-evacuate and if so, did the systems function? <br />
						<small>If no, detail issue and action taken to remedy it</small>
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox5Y" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox5N" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">

					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-fixed" style="width:30px">
						6
					</div>
					<div class="col">
						Did any equipment to assist with the evacuation work as intended? <br />
						<small>If no, detail issue and action taken to remedy it</small>
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox6Y" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox6N" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox6NA" :binary="true" />
					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-fixed" style="width:30px">
						7
					</div>
					<div class="col">
						Occupants accounted for or building determined to be clear in accordance with the evacuation scheme? <br />
						<small>If no, detail issue and action taken to remedy it</small>
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox7Y" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">
						<Checkbox v-model="checkbox7N" :binary="true" />
					</div>
					<div class="col-fixed" style="width:100px">

					</div>
				</div>
				<div class="grid fenz-grid pt-2">
					<div class="col-fixed" style="width:30px">
						8
					</div>
					<div class="col">
						When was the last training session for permanent occupants held?
					</div>
					<div class="col-fixed" style="width:300px">
						<Calendar class="last-training-calendar" v-model="lastTrainingDate" dateFormat="d M yy" :showButtonBar="true" @date-select="onLastTrainingDateChange" />
						<div id="lastTrainingDate" contenteditable="true" class="input-div p-inputtext" />
					</div>
				</div>
			</div>
		</div>
		<div class="fenz-doc-section">
			<div class="header">
				<span>Part E</span>
				<span class="float-right">Additional comments</span>
			</div>
			<div class="pt-3">
				<div contenteditable="true" class="p-inputtext fenz-comments" />
			</div>
		</div>
		<div class="fenz-doc-section">
			<div class="p-2">
				<div class="grid fenz-grid">
					<div class="col-3 fenz-field-name">
						Contact person signature
					</div>
					<div class="col css-image signature-box" @click="displaySignatureModal = true"
							:style="{ backgroundImage: `url('data:image/png;base64,${reportContact.signatureBase64}')` }">
					</div>
				</div>
				<div class="grid fenz-grid pt-2 ">
					<div class="col-3 fenz-field-name">
						Follow up
					</div>
					<div class="col">
						<Checkbox v-model="followUpCheckbox" :binary="true" />
						Tick this box if you would like to speak to someone about this trial.
					</div>
				</div>
			</div>
		</div>
	</div>

	<SignatureModal :open="displaySignatureModal"
					:signatureBase64 = "reportContact.signatureBase64"
					@close="displaySignatureModal=false"
					@updateSignature="updateSignature"/>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyData, PropertyEvacuationData, ReportContact } from '@/api-client/api-client'
	import { format, isValid } from 'date-fns';

	@Options({
		name: 'EvacuationReport',
		props: {
			propertyData: null,
			reportContact: null,
		}
	})
	export default class EvacuationReport extends Vue {

		// Data
		propertyData: PropertyData = new PropertyData();
		evacuation: PropertyEvacuationData = new PropertyEvacuationData();

		reportContact: ReportContact = new ReportContact();

		dateOfEvacuation = null;
		lastTrainingDate = null

		/* Checkbox values */
		checkbox1Y = false;
		checkbox1N = false;
		checkbox2Y = false;
		checkbox2N = false;
		checkbox3Y = false;
		checkbox3N = false;
		checkbox4Y = false;
		checkbox4N = false;
		checkbox5Y = false;
		checkbox5N = false;
		checkbox6Y = false;
		checkbox6N = false;
		checkbox6NA = false;
		checkbox7Y = false;
		checkbox7N = false;
		checkbox8Y = false;
		checkbox8N = false;
		followUpCheckbox = false;

		evacTimeAM = false;
		evacTimePM = false;

		comments = "";

		displaySignatureModal: boolean = false

		created() {
			this.evacuation = this.propertyData.propertyEvacuation != null ? this.propertyData.propertyEvacuation : this.evacuation;
		}

		formattedDate(date: number | Date | null) {
			if (!date) return;

			if (!isValid(date)) return;

			return format(date, 'd MMMM yyyy');
		}

		onDateOfEvacuationChange() {
			(document.getElementById("evacDate") as HTMLDivElement).innerHTML = `${this.formattedDate(this.dateOfEvacuation)}`;
			this.$emit('updateDateOfEvacuation', this.dateOfEvacuation);
		}

		onLastTrainingDateChange() {
			(document.getElementById("lastTrainingDate") as HTMLDivElement).innerHTML = `${this.formattedDate(this.lastTrainingDate)}`;
		}

		// If signature is updated - then display new signature in report
		updateSignature(base64: string) {
			this.reportContact.signatureBase64 = base64;
		}
	}
</script>

<style>
	.fenz-document {
		background-color:white;
	}

	.fenz-logo-size {
		height: 100px;
	}

	.fenz-title {
		float: right;
		color: black;
		font-weight: bold;
	}

	.fenz-link {
		color: #1200F5;
		text-decoration: underline;
	}

	.fenz-field-name {
		background-color: #ddd;
		font-weight: bold;
	}

	.fenz-input {
		width:25%;
	}

	.fenz-comments {
		min-height: 200px;
		resize: vertical;
		overflow: auto;
	}

	.evac-date-calendar {
		z-index: 0;
	}

	.evac-date-div {
		z-index:-1;
		/*hide the div behind the calendar*/ 
		margin-top:-39px;
	}

	.last-training-calendar {
		z-index: 0;
	}

	#lastTrainingDate {
		z-index: -1;
		margin-top: -39px;
	}

	.circled {
		border: 1px solid black;
		border-radius:20px;
	}

	@media print {
		.evac-date-calendar {
			display: none;
		}

		.evac-date-div {
			z-index: 100;
			margin-top: 0px;
		}

		.last-training-calendar {
			display: none;
		}

		#lastTrainingDate {
			z-index: 100;
			margin-top: 0px;
		}
	}

</style>